import React, { useState, useEffect } from 'react';
import { Calculator, Phone, Wrench, Plus, Trash2, Save } from 'lucide-react';
import { fetchMechanicsData, saveMechanicData,getIncentivesData} from '../services/mechanicsService';

const MechanicsComponent = () => {
  // Services state with default values from your table
  const [services, setServices] = useState([
    { id: 1, name: 'FIBRE SAFE', price: 14.99 },
    { id: 2, name: 'SOGEA', price: 69.98 },
    { id: 3, name: '4G BB', price: 55.00 },
    { id: 4, name: 'ISDN 2 CH', price: 0 },
    { id: 5, name: 'STARLINK', price: 120.00 },
    { id: 6, name: 'ANALOGUE LINE', price: 29.99 },
    { id: 7, name: 'LICENSE MAINT', price: 8.50 },
    { id: 8, name: 'T58W', price: 4.49 },
    { id: 9, name: 'T57W', price: 2.49 },
    { id: 10, name: 'T54W', price: 1.49 },
    { id: 11, name: 'DECT', price: 1.49 },
    { id: 12, name: 'FIBRE AI', price: 9.99 },
    { id: 13, name: 'FIBRE AUDIO', price: 14.99 },
    { id: 14, name: 'SIP TRUNK BUNDLE', price: 1.50 },
    { id: 15, name: 'FTTC BB', price: 45.00 },
    { id: 16, name: 'FIBRE FAILSAFE', price: 24.99 },
    { id: 17, name: 'LEASED LINE', price: 250.00 },
    { id: 18, name: 'GRANDSTREAM 3470', price: 4.49 },
    { id: 19, name: 'GRANDSTREAM 3480', price: 4.49 },
    { id: 20, name: 'CISCO 9871', price: 4.49 },
    { id: 21, name: 'YEALINK T88', price: 4.49 },
    { id: 22, name: 'YEALINK T85', price:1.60 },
    { id: 23, name: 'YEALINK T87', price: 2.60}

  ]);

  // Equipment state with the values you provided
  const [equipment, setEquipment] = useState([
    { id: 1, name: 'SINGLE LIFETIME HOSTED LICENSE', price: 0 },
    { id: 2, name: 'T54W', price: 112.84 },
    { id: 3, name: 'T57W', price: 160.10 },
    { id: 4, name: 'T58W PRO', price: 216.28 },
    { id: 5, name: 'NUMBER PORT', price: 13.00 },
    { id: 6, name: 'NEW NUMBER PROVISION 2-9', price: 12.00 },
    { id: 7, name: 'IP DECT', price: 80.00 },
    { id: 8, name: 'SIPP BELL', price: 360.00 },
    { id: 9, name: 'WIRELESS HEADSET', price: 135.00 },
    { id: 10, name: 'DOOR ENTRY SYSTEM (AVERAGE ONE)', price: 250.00 },
    { id: 11, name: 'IPAD', price: 500.00 },
    { id: 12, name: 'CAT 5E CABLING', price: 100.00 },
    { id: 13, name: 'SITE MOVE', price: 1200.00 },
    { id: 14, name: 'Netgear GS108LP SWITCH', price: 187.00 },
    { id: 15, name: 'DRAYTEK WI-FI ROUTER', price: 190.00 },
    { id: 16, name: 'ROBUSTEL 4G ROUTER', price: 288.00 },
    { id: 17, name: 'NEW BASIC LINE', price: 59.01 },
    { id: 18, name: 'OVERRIDE COMMS', price: 175.00 },
    { id: 19, name: 'TITAL CAT 5 CABLE (2M)', price: 1.26 },
    { id: 20, name: 'INSTALLATION CHARGE', price: 1000.00 },
    { id: 21, name: 'WIFI BOOSTER', price: 50.00 },
    { id: 22, name: 'LG TV', price: 350.00 },
    { id: 23, name: 'STARLINK', price: 850.00 },
    { id: 24, name: 'ADMIN FEE', price: 180.00 },
    { id: 25, name: 'GRANDSTREAM 3470', price: 216.28 },
    { id: 26, name: 'GRANDSTREAM 3480', price: 216.28 },
    { id: 27, name: 'CISCO 9871', price: 216.28 },
    { id: 28, name: 'YEALINK T88', price: 216.28 },
    { id: 29, name: 'YEALINK T85', price: 120 },
    { id: 30, name: 'YEALINK T87', price: 170 }


  ]);

  // Microsoft 365 licence state (OCTOPUSHX pricing — flat monthly rate regardless of term length)
  const [licenses, setLicenses] = useState([
    { id: 1, name: 'MICROSOFT BUSINESS BASIC', price: 6.48 },
    { id: 2, name: 'MICROSOFT BUSINESS STANDARD', price: 11.52 },
    { id: 3, name: 'MICROSOFT BUSINESS PREMIUM', price: 20.28 },
    { id: 4, name: 'MICROSOFT EXCHANGE ONLINE PLAN 1 50 GIG', price: 3.72 },
    { id: 5, name: 'MICROSOFT EXCHANGE ONLINE PLAN 2 100 GIG', price: 7.44 }
  ]);

  // IT Support pricing
  const [itSupport, setItSupport] = useState([
    { id: 1, name: 'PER STATION + MICROSOFT LICENCE BASIC', price: 30.00 },
    { id: 2, name: 'IT SUPPORT (PER STATION)', price: 45.00 }
  ]);

  const [newService, setNewService] = useState({ name: '', price: '' });
  const [newEquipment, setNewEquipment] = useState({ name: '', price: '' });
  const [newLicense, setNewLicense] = useState({ name: '', price: '' });
  const [newItSupport, setNewItSupport] = useState({ name: '', price: '' });
  const [servicesTotal, setServicesTotal] = useState(0);
  const [equipmentTotal, setEquipmentTotal] = useState(0);
  const [commission, setCommission] = useState(17);
  const [incentivesEnabled, setIncentivesEnabled] = useState(false);
  const [incentivesNotes, setIncentivesNotes] = useState('');
  const [cost, setCost] = useState('');

useEffect(() => {
  const fetchMechanics = async () => {
    try {
      const response = await fetchMechanicsData();
      //console.log("🔍 Full API Response:", response);
      
      // ✅ FIX: Access response.data instead of response[0]
      if (response && response.data) {
        const data = response.data;
        //console.log("📦 Data structure:", data);
        //console.log("📦 Data keys:", Object.keys(data));
        
        // Load saved services if they exist
        if (data.services && data.services.length > 0) {
          setServices(data.services);
          //console.log("✅ Services loaded:", data.services.length);
        }
        
        // Load saved equipment if they exist
        if (data.equipment && data.equipment.length > 0) {
          setEquipment(data.equipment);
          //console.log("✅ Equipment loaded:", data.equipment.length);
        }

        // Load saved Microsoft licenses if they exist
        if (data.licenses && data.licenses.length > 0) {
          setLicenses(data.licenses);
          //console.log("✅ Licenses loaded:", data.licenses.length);
        }

        // Load saved IT support pricing if it exists
        if (data.it_support && data.it_support.length > 0) {
          setItSupport(data.it_support);
          //console.log("✅ IT support loaded:", data.it_support.length);
        }

        // Debug each field with more details
        //console.log("🔍 Field values:");
        //console.log("incentives_enabled:", data.incentives_enabled, "Type:", typeof data.incentives_enabled);
       // console.log("incentives_notes:", data.incentives_notes, "Type:", typeof data.incentives_notes);
        //console.log("cost:", data.cost, "Type:", typeof data.cost);
        //console.log("commission:", data.commission, "Type:", typeof data.commission);

        // Set the values with explicit conversion
        if (data.incentives_enabled !== undefined && data.incentives_enabled !== null) {
          const enabled = Boolean(Number(data.incentives_enabled)); // Convert string/number to boolean
          setIncentivesEnabled(enabled);
          //console.log("✅ incentives_enabled set to:", enabled);
        }

        if (data.incentives_notes !== undefined && data.incentives_notes !== null) {
          setIncentivesNotes(String(data.incentives_notes));
          //console.log("✅ incentives_notes set to:", data.incentives_notes);
        }

        if (data.cost !== undefined && data.cost !== null) {
          setCost(String(data.cost));
          //console.log("✅ cost set to:", data.cost);
        }

        if (data.commission !== undefined && data.commission !== null) {
          const commissionValue = parseFloat(data.commission);
          setCommission(commissionValue);
          //console.log("✅ commission set to:", commissionValue);
        }
        
      } else {
        console.log("❌ No data in response");
      }
    } catch (err) {
      console.error('❌ Error fetching saved data:', err);
    }
  };

  fetchMechanics();
}, []);
// Effect to handle incentives disabled state
useEffect(() => {
  if (!incentivesEnabled) {
    setCost('0');
    setIncentivesNotes('');
  }
}, [incentivesEnabled]);

  const handleServiceChange = (id, field, value) => {
    setServices(prev => 
      prev.map(service => 
        service.id === id 
          ? { ...service, [field]: field === 'price' ? parseFloat(value) || 0 : value } 
          : service
      )
    );
  };

  const handleEquipmentChange = (id, field, value) => {
    setEquipment(prev => 
      prev.map(item => 
        item.id === id 
          ? { ...item, [field]: field === 'price' ? parseFloat(value) || 0 : value } 
          : item
      )
    );
  };

  const handleLicenseChange = (id, field, value) => {
    setLicenses(prev =>
      prev.map(license =>
        license.id === id
          ? { ...license, [field]: field === 'price' ? parseFloat(value) || 0 : value }
          : license
      )
    );
  };

  const handleItSupportChange = (id, field, value) => {
    setItSupport(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, [field]: field === 'price' ? parseFloat(value) || 0 : value }
          : item
      )
    );
  };

  const handleAddNewService = () => {
    if (newService.name.trim() && newService.price !== '') {
      const price = parseFloat(newService.price) || 0;
      const newId = Math.max(...services.map(s => s.id), 0) + 1;
      
      setServices(prev => [
        ...prev, 
        { 
          id: newId, 
          name: newService.name.trim(), 
          price: price 
        }
      ]);
      
      setNewService({ name: '', price: '' });
    }
  };

  const handleAddNewEquipment = () => {
    if (newEquipment.name.trim() && newEquipment.price !== '') {
      const price = parseFloat(newEquipment.price) || 0;
      const newId = Math.max(...equipment.map(e => e.id), 0) + 1;
      
      setEquipment(prev => [
        ...prev, 
        { 
          id: newId, 
          name: newEquipment.name.trim(), 
          price: price 
        }
      ]);
      
      setNewEquipment({ name: '', price: '' });
    }
  };

  const handleAddNewLicense = () => {
    if (newLicense.name.trim() && newLicense.price !== '') {
      const price = parseFloat(newLicense.price) || 0;
      const newId = Math.max(...licenses.map(l => l.id), 0) + 1;

      setLicenses(prev => [
        ...prev,
        {
          id: newId,
          name: newLicense.name.trim(),
          price: price
        }
      ]);

      setNewLicense({ name: '', price: '' });
    }
  };

  const handleAddNewItSupport = () => {
    if (newItSupport.name.trim() && newItSupport.price !== '') {
      const price = parseFloat(newItSupport.price) || 0;
      const newId = Math.max(...itSupport.map(i => i.id), 0) + 1;

      setItSupport(prev => [
        ...prev,
        {
          id: newId,
          name: newItSupport.name.trim(),
          price: price
        }
      ]);

      setNewItSupport({ name: '', price: '' });
    }
  };

  const handleRemoveService = (id) => {
    setServices(prev => prev.filter(service => service.id !== id));
  };

  const handleRemoveEquipment = (id) => {
    setEquipment(prev => prev.filter(item => item.id !== id));
  };

  const handleRemoveLicense = (id) => {
    setLicenses(prev => prev.filter(license => license.id !== id));
  };

  const handleRemoveItSupport = (id) => {
    setItSupport(prev => prev.filter(item => item.id !== id));
  };

  const resetForm = () => {
    // Reset to default services
    setServices([
      { id: 1, name: 'FIBRE SAFE', price: 14.99 },
      { id: 2, name: 'SOGEA', price: 69.98 },
      { id: 3, name: '4G BB', price: 55.00 },
      { id: 4, name: 'ISDN 2 CH', price: 0 },
      { id: 5, name: 'STARLINK', price: 120.00 },
      { id: 6, name: 'ANALOGUE LINE', price: 29.99 },
      { id: 7, name: 'LICENSE MAINT', price: 8.50 },
      { id: 8, name: 'T58W', price: 4.49 },
      { id: 9, name: 'T57W', price: 2.49 },
      { id: 10, name: 'T54W', price: 1.49 },
      { id: 11, name: 'DECT', price: 1.49 },
      { id: 12, name: 'FIBRE AI', price: 9.99 },
      { id: 13, name: 'FIBRE AUDIO', price: 14.99 },
      { id: 14, name: 'SIP TRUNK BUNDLE', price: 1.50 },
      { id: 15, name: 'FTTC BB', price: 45.00 },
      { id: 16, name: 'FIBRE FAILSAFE', price: 24.99 },
      { id: 17, name: 'LEASED LINE', price: 250.00 },
      { id: 18, name: 'GRANDSTREAM 3470', price: 4.49 },
      { id: 19, name: 'GRANDSTREAM 3480', price: 4.49 },
      { id: 20, name: 'CISCO 9871', price: 4.49 },
      { id: 21, name: 'YEALINK T88', price: 4.49 }
    ]);
    // Reset to default equipment
    setEquipment([
      { id: 1, name: 'SINGLE LIFETIME HOSTED LICENSE', price: 0 },
      { id: 2, name: 'T54W', price: 112.84 },
      { id: 3, name: 'T57W', price: 160.10 },
      { id: 4, name: 'T58W PRO', price: 216.28 },
      { id: 5, name: 'NUMBER PORT', price: 13.00 },
      { id: 6, name: 'NEW NUMBER PROVISION 2-9', price: 12.00 },
      { id: 7, name: 'IP DECT', price: 80.00 },
      { id: 8, name: 'SIPP BELL', price: 360.00 },
      { id: 9, name: 'WIRELESS HEADSET', price: 135.00 },
      { id: 10, name: 'DOOR ENTRY SYSTEM (AVERAGE ONE)', price: 250.00 },
      { id: 11, name: 'IPAD', price: 500.00 },
      { id: 12, name: 'CAT 5E CABLING', price: 100.00 },
      { id: 13, name: 'SITE MOVE', price: 1200.00 },
      { id: 14, name: 'Netgear GS108LP SWITCH', price: 187.00 },
      { id: 15, name: 'DRAYTEK WI-FI ROUTER', price: 190.00 },
      { id: 16, name: 'ROBUSTEL 4G ROUTER', price: 288.00 },
      { id: 17, name: 'NEW BASIC LINE', price: 59.01 },
      { id: 18, name: 'OVERRIDE COMMS', price: 175.00 },
      { id: 19, name: 'TITAL CAT 5 CABLE (2M)', price: 1.26 },
      { id: 20, name: 'INSTALLATION CHARGE', price: 1000.00 },
      { id: 21, name: 'WIFI BOOSTER', price: 50.00 },
      { id: 22, name: 'LG TV', price: 350.00 },
      { id: 23, name: 'STARLINK', price: 850.00 },
      { id: 24, name: 'ADMIN FEE', price: 180.00 },
      { id: 25, name: 'GRANDSTREAM 3470', price: 216.28 },
      { id: 26, name: 'GRANDSTREAM 3480', price: 216.28 },
      { id: 27, name: 'CISCO 9871', price: 216.28 },
      { id: 28, name: 'YEALINK T88', price: 216.28 }
    ]);
    // Reset Microsoft licenses to defaults
    setLicenses([
      { id: 1, name: 'MICROSOFT BUSINESS BASIC', price: 6.48 },
      { id: 2, name: 'MICROSOFT BUSINESS STANDARD', price: 11.52 },
      { id: 3, name: 'MICROSOFT BUSINESS PREMIUM', price: 20.28 },
      { id: 4, name: 'MICROSOFT EXCHANGE ONLINE PLAN 1 50 GIG', price: 3.72 },
      { id: 5, name: 'MICROSOFT EXCHANGE ONLINE PLAN 2 100 GIG', price: 7.44 }
    ]);
    // Reset IT support pricing to defaults
    setItSupport([
      { id: 1, name: 'IT SERVICE', price: 25.00 },
      { id: 2, name: 'PER STATION + MICROSOFT LICENCE', price: 35.00 },
      { id: 3, name: 'IT SUPPORT (PER STATION)', price: 45.00 }
    ]);
    // Reset incentives and notes
    setIncentivesEnabled(false);
  setIncentivesNotes('');
  setCost('0');
  };

  const handleSave = async () => {
    try {
      const dataToSave = {
        services,
        equipment,
        licenses,
        it_support: itSupport,
        commission,
        incentives_enabled: incentivesEnabled,  // snake_case
        incentives_notes: incentivesEnabled ? incentivesNotes : '', // Clear notes if disabled
        cost: incentivesEnabled ? cost : '0'
      };
      await saveMechanicData(dataToSave);
      alert('Data saved successfully!');
    } catch (error) {
      console.error('Error saving data:', error);
      alert('Failed to save data');
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-6 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl shadow-lg">
      <div className="text-center mb-8">
        <div className="flex items-center justify-center mb-4">
          <Wrench className="h-8 w-8 text-blue-600 mr-2" />
          <h1 className="text-3xl font-bold text-gray-800">Mechanics Calculator</h1>
        </div>
        <p className="text-gray-600">Enter values to calculate mechanical properties automatically</p>
      </div>

      {/* Commission Section */}
      <div className="mb-6">
        <label className="block text-gray-700 font-medium mb-2">
          Sales Commission (%)
        </label>
        <input
          type="number"
          value={commission}
          onChange={(e) => setCommission(parseFloat(e.target.value) || 0)}
          className="w-32 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          step="0.1"
        />
      </div>

      {/* Standalone Incentives Section */}
<div className="mb-8 bg-gradient-to-br from-white to-blue-50 p-6 rounded-2xl shadow-lg border border-blue-100">
  <div className="flex items-center mb-6">
    <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-2 rounded-lg mr-3">
      <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
      </svg>
    </div>
    <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
      Incentives Settings
    </h2>
  </div>
  
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
    {/* Option 1: Checkbox Card */}
    <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start space-x-3">
        <div className="flex items-center h-5 mt-0.5">
          <input
            type="checkbox"
            id="incentivesEnabled"
            checked={incentivesEnabled}
            onChange={(e) => setIncentivesEnabled(e.target.checked)}
            className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-2 border-gray-300 rounded-lg transition-all duration-200"
          />
        </div>
        <div className="flex-1">
          <label htmlFor="incentivesEnabled" className="block text-lg font-semibold text-gray-800 mb-2">
            Enable Incentives
          </label>
          <p className="text-sm text-gray-600 leading-relaxed">
            Activate special incentives and bonus calculations for this project.
          </p>
        </div>
      </div>
      {incentivesEnabled && (
        <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
          <div className="flex items-center text-green-700">
            <svg className="h-4 w-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-medium">Incentives are currently active</span>
          </div>
        </div>
      )}
    </div>

    {/* Option 2: Cost Input Card */}
    <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300">
      <div className="flex items-center mb-3">
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 p-2 rounded-lg mr-3">
          <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <label htmlFor="cost" className="block text-lg font-semibold text-gray-800">
          Total Cost
        </label>
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <span className="text-gray-500 font-medium">£</span>
        </div>
        <input
          type="number"
          id="cost"
          value={cost}
          onChange={(e) => setCost(e.target.value)}
          disabled={!incentivesEnabled}
          className={`w-full pl-8 pr-4 py-3 border-2 rounded-xl focus:ring-2 transition-all duration-200 text-lg font-medium ${
            incentivesEnabled 
              ? 'border-gray-200 focus:border-blue-500 focus:ring-blue-200' 
              : 'border-gray-100 bg-gray-50 text-gray-400 cursor-not-allowed'
          }`}
          
          placeholder="0.00"
        />
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Enter the total project cost including all expenses
      </p>
    </div>

    {/* Option 3: Notes Textarea Card */}
    <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300">
      <div className="flex items-center mb-3">
        <div className="bg-gradient-to-r from-purple-500 to-pink-600 p-2 rounded-lg mr-3">
          <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </div>
        <label htmlFor="incentivesNotes" className="block text-lg font-semibold text-gray-800">
          Incentives Notes
        </label>
      </div>
      <textarea
        id="incentivesNotes"
        value={incentivesNotes}
        onChange={(e) => setIncentivesNotes(e.target.value)}
        rows={4}
        disabled={!incentivesEnabled}
  
      className={`w-full px-4 py-3 border-2 rounded-xl focus:ring-2 transition-all duration-200 resize-none ${
        incentivesEnabled 
          ? 'border-gray-200 focus:border-blue-500 focus:ring-blue-200' 
          : 'border-gray-100 bg-gray-50 text-gray-400 cursor-not-allowed'
      }`}
      placeholder={incentivesEnabled 
        ? "Describe incentive conditions, special terms, bonus structures, or any relevant information..." 
        : "Enable incentives to add notes"}
     
      />
      <div className="flex justify-between items-center mt-2">
        <p className="text-xs text-gray-500">
          {incentivesNotes.length}/500 characters
        </p>
        <div className="flex space-x-1">
          <button
            type="button"
            onClick={() => setIncentivesNotes('')}
            disabled={!incentivesEnabled}
            className={`text-xs transition-colors duration-200 ${
              incentivesEnabled 
                ? 'text-gray-500 hover:text-red-500' 
                : 'text-gray-300 cursor-not-allowed'
            }`}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  </div>

  {/* Summary Bar */}
  <div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-200">
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <div className={`w-3 h-3 rounded-full ${incentivesEnabled ? 'bg-green-500 animate-pulse' : 'bg-gray-400'}`}></div>
        <span className="text-sm font-medium text-gray-700">
          Status: {incentivesEnabled ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div className="text-right">
        <span className="text-sm text-gray-600">Total Cost: </span>
        <span className="text-lg font-bold text-green-600">
          £{cost ? parseFloat(cost).toFixed(2) : '0.00'}
        </span>
      </div>
    </div>
  </div>
</div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Left Column - Services Management */}
        <div className="space-y-6">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Services Management</h2>
            
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-700 mb-3">Current Services</h3>
              <div className="space-y-3">
                {services.map(service => (
                  <div key={service.id} className="grid grid-cols-12 gap-2 items-center">
                    <div className="col-span-5">
                      <input
                        type="text"
                        value={service.name}
                        readOnly
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      />
                    </div>
                    <div className="col-span-4">
                      <input
                        type="number"
                        value={service.price}
                        onChange={(e) => handleServiceChange(service.id, 'price', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        step="0.01"
                      />
                    </div>
                    <div className="col-span-3 flex justify-end">
                      <button
                        onClick={() => handleRemoveService(service.id)}
                        className="p-2 text-red-500 hover:text-red-700 rounded-full hover:bg-red-50"
                        title="Remove service"
                      >
                       {/* <Trash2 className="h-4 w-4" /> */}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="mt-6">
              <h3 className="text-lg font-medium text-gray-700 mb-3">Add New Service</h3>
              <div className="grid grid-cols-12 gap-2">
                <div className="col-span-5">
                  <input
                    type="text"
                    value={newService.name}
                    onChange={(e) => setNewService({...newService, name: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="Service name"
                  />
                </div>
                <div className="col-span-4">
                  <input
                    type="number"
                    value={newService.price}
                    onChange={(e) => setNewService({...newService, price: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="Price"
                    step="0.01"
                  />
                </div>
                <div className="col-span-3 flex justify-end">
                  <button
                    onClick={handleAddNewService}
                    className="p-2 text-green-500 hover:text-green-700 rounded-full hover:bg-green-50"
                    title="Add service"
                  >
                    <Plus className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Equipment Management */}
        <div className="space-y-6">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Equipment Management</h2>
            
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-700 mb-3">Current Equipment</h3>
              <div className="space-y-3">
                {equipment.map(item => (
                  <div key={item.id} className="grid grid-cols-12 gap-2 items-center">
                    <div className="col-span-5">
                      <input
                        type="text"
                        value={item.name}
                        readOnly
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      />
                    </div>
                    <div className="col-span-4">
                      <input
                        type="number"
                        value={item.price}
                        onChange={(e) => handleEquipmentChange(item.id, 'price', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        step="0.01"
                      />
                    </div>
                    <div className="col-span-3 flex justify-end">
                      <button
                        onClick={() => handleRemoveEquipment(item.id)}
                        className="p-2 text-red-500 hover:text-red-700 rounded-full hover:bg-red-50"
                        title="Remove equipment"
                      >
                        {/* <Trash2 className="h-4 w-4" /> */}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="mt-6">
              <h3 className="text-lg font-medium text-gray-700 mb-3">Add New Equipment</h3>
              <div className="grid grid-cols-12 gap-2">
                <div className="col-span-5">
                  <input
                    type="text"
                    value={newEquipment.name}
                    onChange={(e) => setNewEquipment({...newEquipment, name: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="Equipment name"
                  />
                </div>
                <div className="col-span-4">
                  <input
                    type="number"
                    value={newEquipment.price}
                    onChange={(e) => setNewEquipment({...newEquipment, price: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="Price"
                    step="0.01"
                  />
                </div>
                <div className="col-span-3 flex justify-end">
                  <button
                    onClick={handleAddNewEquipment}
                    className="p-2 text-green-500 hover:text-green-700 rounded-full hover:bg-green-50"
                    title="Add equipment"
                  >
                    <Plus className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Microsoft 365 Licences Management */}
      <div className="mt-8 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Microsoft 365 Licences</h2>
        <p className="text-sm text-gray-500 mb-4">OCTOPUSHX pricing — flat monthly rate regardless of term length (12/24/36/60/84 months)</p>

        <div className="mb-6">
          <h3 className="text-lg font-medium text-gray-700 mb-3">Current Licences</h3>
          <div className="space-y-3">
            {licenses.map(license => (
              <div key={license.id} className="grid grid-cols-12 gap-2 items-center">
                <div className="col-span-5">
                  <input
                    type="text"
                    value={license.name}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  />
                </div>
                <div className="col-span-4">
                  <input
                    type="number"
                    value={license.price}
                    onChange={(e) => handleLicenseChange(license.id, 'price', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    step="0.01"
                  />
                </div>
                <div className="col-span-3 flex justify-end">
                  <button
                    onClick={() => handleRemoveLicense(license.id)}
                    className="p-2 text-red-500 hover:text-red-700 rounded-full hover:bg-red-50"
                    title="Remove licence"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-lg font-medium text-gray-700 mb-3">Add New Licence</h3>
          <div className="grid grid-cols-12 gap-2">
            <div className="col-span-5">
              <input
                type="text"
                value={newLicense.name}
                onChange={(e) => setNewLicense({...newLicense, name: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                placeholder="Licence name"
              />
            </div>
            <div className="col-span-4">
              <input
                type="number"
                value={newLicense.price}
                onChange={(e) => setNewLicense({...newLicense, price: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                placeholder="Price"
                step="0.01"
              />
            </div>
            <div className="col-span-3 flex justify-end">
              <button
                onClick={handleAddNewLicense}
                className="p-2 text-green-500 hover:text-green-700 rounded-full hover:bg-green-50"
                title="Add licence"
              >
                <Plus className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* IT Support Pricing */}
      <div className="mt-8 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">IT Support Pricing</h2>

        <div className="mb-6">
          <h3 className="text-lg font-medium text-gray-700 mb-3">Current IT Support Items</h3>
          <div className="space-y-3">
            {itSupport.map(item => (
              <div key={item.id} className="grid grid-cols-12 gap-2 items-center">
                <div className="col-span-5">
                  <input
                    type="text"
                    value={item.name}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  />
                </div>
                <div className="col-span-4">
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handleItSupportChange(item.id, 'price', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    step="0.01"
                  />
                </div>
                <div className="col-span-3 flex justify-end">
                  <button
                    onClick={() => handleRemoveItSupport(item.id)}
                    className="p-2 text-red-500 hover:text-red-700 rounded-full hover:bg-red-50"
                    title="Remove item"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-lg font-medium text-gray-700 mb-3">Add New IT Support Item</h3>
          <div className="grid grid-cols-12 gap-2">
            <div className="col-span-5">
              <input
                type="text"
                value={newItSupport.name}
                onChange={(e) => setNewItSupport({...newItSupport, name: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                placeholder="Item name"
              />
            </div>
            <div className="col-span-4">
              <input
                type="number"
                value={newItSupport.price}
                onChange={(e) => setNewItSupport({...newItSupport, price: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                placeholder="Price"
                step="0.01"
              />
            </div>
            <div className="col-span-3 flex justify-end">
              <button
                onClick={handleAddNewItSupport}
                className="p-2 text-green-500 hover:text-green-700 rounded-full hover:bg-green-50"
                title="Add item"
              >
                <Plus className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-white p-6 rounded-lg shadow-md">
        <div className="flex justify-between items-center">
          <div className="inline-flex items-center space-x-4">
            <button
              onClick={handleSave}
              className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200 flex items-center"
            >
              <Save className="h-5 w-5 mr-2" />
              Save
            </button>
            <button
              onClick={resetForm}
              className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            >
              Reset All Fields
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MechanicsComponent;